import classNames from 'classnames'
import { useLocation } from 'react-router-dom'
import { Logo } from 'components/atoms'
import { ROUTE_ABOUT, ROUTE_STORE_DETAIL } from 'constant'

export const Header = () => {
  const { pathname } = useLocation()

  return (
    <div
      className={classNames({
        'flex flex-col items-center': true,
        'gap-[18px]': !pathname.includes(ROUTE_STORE_DETAIL),
        hidden: pathname.includes(ROUTE_ABOUT),
      })}
    >
      <div className="w-full h-[84px] flex items-center justify-center px-10">
        <Logo />
      </div>
    </div>
  )
}
